// extracted by mini-css-extract-plugin
export var codeoverflow = "style-module--codeoverflow--mljXw";
export var hide = "style-module--hide--V4bjB";
export var highlight = "style-module--highlight--VMyic";
export var mouseover = "style-module--mouseover--LgECI";
export var panel = "style-module--panel--wGqEj";
export var pre = "style-module--pre--dGE3S";
export var root = "style-module--root--GNtQx";